import { useEffect, useRef, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, ClickAwayListener, Paper, Popper, CardContent, Grid, Stack, Typography } from '@mui/material';

// project import
import IconButton from '@/from-theme/components/@extended/IconButton';
import Transitions from '@/from-theme/components/@extended/Transitions';
import { ThemeMode } from 'config';
import MainCard from '@/from-theme/components/MainCard';
import Avatar from '@/from-theme/components/@extended/Avatar';
import ProfileTab from './Profile/ProfileTab';

// assets
import { MoreOutlined } from '@ant-design/icons';

// ==============================|| HEADER CONTENT - MOBILE ||============================== //

const MobileSection = () => {
  const theme = useTheme();

  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const [anchorPos, setAnchorPos] = useState(null);

  const handleToggle = () => {
    setOpen((prevOpen) => {
      const next = !prevOpen;
      if (next && anchorRef.current) {
        const rect = anchorRef.current.getBoundingClientRect();
        const menuWidth = 290; // match MainCard maxWidth
        const left = Math.max(8, rect.right - menuWidth + window.scrollX);
        const top = rect.bottom + 8 + window.scrollY;
        setAnchorPos({ top: Math.round(top), left: Math.round(left) });
      } else {
        setAnchorPos(null);
      }
      return next;
    });
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const prevOpen = useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  const iconBackColorOpen = theme.palette.mode === ThemeMode.DARK ? 'grey.200' : 'grey.300';
  const iconBackColor = theme.palette.mode === ThemeMode.DARK ? 'background.default' : 'grey.100';

  return (
    <>
      <Box sx={{ flexShrink: 0, ml: 0.75 }}>
        <IconButton
          sx={{ color: 'text.primary', bgcolor: open ? iconBackColorOpen : iconBackColor }}
          aria-label="open more menu"
          ref={anchorRef}
          aria-controls={open ? 'menu-list-grow' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
          color="secondary"
          variant="light"
        >
          <MoreOutlined />
        </IconButton>
      </Box>
      <Popper
        placement="bottom-start"
        open={open}
        anchorReference={anchorPos ? 'anchorPosition' : 'anchorEl'}
        anchorPosition={anchorPos}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal={false}
        sx={{ width: 'auto' }}
        popperOptions={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 9]
              }
            }
          ]
        }}
      >
        {({ TransitionProps }) => (
          <Transitions type="fade" in={open} {...TransitionProps}>
            <Paper sx={{ boxShadow: theme.customShadows.z1 }}>
              <ClickAwayListener onClickAway={handleClose}>
                  <Box sx={{ px: 1 }}>
                    <MainCard elevation={0} border={false} content={false} sx={{ maxWidth: 290 }}>
                        <CardContent sx={{ px: 2.5, pt: 3 }}>
                          <Grid container justifyContent="space-between" alignItems="center">
                            <Grid item>
                              <Stack direction="row" spacing={1.25} alignItems="center">
                                <Avatar alt="profile user" src={null} sx={{ width: 32, height: 32 }} />
                                <Stack>
                                  <Typography variant="h6">User</Typography>
                                  <Typography variant="body2" color="textSecondary">Designation</Typography>
                                </Stack>
                              </Stack>
                            </Grid>
                          </Grid>
                        </CardContent>
                        <Box sx={{ borderTop: 1, borderColor: 'divider' }}>
                          <ProfileTab />
                        </Box>
                      </MainCard>
                  </Box>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>
    </>
  );
};

export default MobileSection;
